import Vue from 'vue'
import Router from 'vue-router'

import Main from './views/main/index.vue'
import Login from '@/views/login/index.vue'
import ModuleOrderManage from '@/views/module-order-manage/index.vue'
import ModuleBillLog from '@/views/module-bill-log/index.vue'
import ModuleFromUserManage from '@/views/module-from-user-manage/index.vue'
import ModulePlatformAuthManage from '@/views/module-platform-auth-manage/index.vue'
import ModuleUserGroupManage from '@/views/module-user-group-manage/index.vue'
import ModuleUserManage from '@/views/module-user-manage/index.vue'
import ModuleCourierManage from '@/views/module-courier-manage/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/main',
      component: Main,
      redirect: '/main/module-order-manage',
      children: [
        {
          path: 'module-courier-manage',
          component: ModuleCourierManage
        },
        {
          path: 'module-bill-log',
          component: ModuleBillLog
        },
        {
          path: 'module-from-user-manage',
          component: ModuleFromUserManage
        },
        {
          path: 'module-order-manage',
          component: ModuleOrderManage
        },
        {
          path: 'module-user-group-manage',
          component: ModuleUserGroupManage
        },
        {
          path: 'module-user-manage',
          component: ModuleUserManage
        }
      ]
    },
    {
      path: '/login',
      component: Login
    }
  ]
})
